"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiConfig_1 = require("../config/ApiConfig");
var ApiManager_1 = require("../ApiManager");
var HelpApi = /** @class */ (function (_super) {
    __extends(HelpApi, _super);
    function HelpApi() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.GET_NEWSFEED_LIST = '/api/v1/newsFeed/list';
        _this.UPDATE_NEWSFEED_LIKE_STATE = '/api/v1/newsFeed';
        /**
         * newsFeed 획득 api
         * @param token
         * @param page
         * @returns
         */
        _this.getNewsFeed = function (token, page) {
            return ApiConfig_1.Axios.Client({
                header: { token: token },
                method: 'get',
                url: "".concat(_this.GET_NEWSFEED_LIST, "/").concat(page),
            });
        };
        /**
         *
         * @param token
         * @param newsFeedId
         * @param isLikeUp: true이면 좋아요 false이면 좋아요 제거
         */
        _this.updateNewsfeedLikeState = function (token, newsFeedId, isLikeUp) {
            var likeState = isLikeUp ? 'setLike' : 'delLike';
            var data = {
                newsFeedId: newsFeedId,
            };
            return ApiConfig_1.Axios.Client({
                header: { token: token },
                url: "".concat(_this.UPDATE_NEWSFEED_LIKE_STATE, "/").concat(likeState),
                data: data,
            });
        };
        return _this;
    }
    HelpApi.getInstance = function (initValue) {
        if (!HelpApi.classInstance) {
            this.classInstance = new HelpApi(initValue);
        }
        return this.classInstance;
    };
    return HelpApi;
}(ApiManager_1.ApiManager));
exports.default = HelpApi;
